import config from './config'
import Vue from 'vue'

let route = {
  getAssembleTime (routeId) {
    return Vue.http.get(`${config.apiWe}/product/route/${routeId}/assembleTime`)
      .then(({data}) => data)
  },

  getAssemblePlace (routeId) {
    return Vue.http.get(`${config.apiWe}/product/route/${routeId}/assemblePlace`)
      .then(({data}) => data)
  }

}

let tag = {
  getTags () {
    return Vue.http.get(`${config.apiWe}/product/term`)
      .then(({data}) => data)
  }
}

export default {
  route,
  tag
}



/** WEBPACK FOOTER **
 ** ./src/libs/api.js
 **/